import React from 'react';
import { BuildingLibraryIcon } from '@heroicons/react/16/solid';
import { BankConnectionReturn } from '../../clients/rust-api-client';
import { PropertyPicker } from '../../violation/linear/PropertyPicker';

/**
 * Which bank connection a Banking-page section is showing (#665): the
 * Linear property chip, in place of the native selects the lockbox,
 * returned-payment and NSF sections each had. The new-connection modal's
 * Bank chip uses the same picker.
 */
export const connectionLabel = (c: BankConnectionReturn): string =>
  c.label || c.client_id;

interface Props {
  connections: BankConnectionReturn[];
  value: string | null;
  onChange: (id: string) => void;
  className?: string;
}

export const ConnectionPicker: React.FC<Props> = ({
  connections,
  value,
  onChange,
  className,
}) => {
  const current = connections.find((c) => c.id === value);
  return (
    <PropertyPicker
      options={connections.map((c) => ({ value: c.id, label: connectionLabel(c) }))}
      value={value}
      onChange={onChange}
      placeholder="Bank connection…"
      ariaLabel={
        current ? `Bank connection: ${connectionLabel(current)}` : 'Choose bank connection'
      }
      className={className}
      trigger={
        <>
          <BuildingLibraryIcon className="h-3.5 w-3.5 text-fg-muted" aria-hidden />
          {current ? (
            connectionLabel(current)
          ) : (
            <span className="text-fg-muted">Bank connection</span>
          )}
        </>
      }
    />
  );
};
